<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>RegistSdk</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/regist-sdk/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "release",
          linkList: [ur + "release/regist-sdk.umd.js"]
        },
        {
          label: "1.0.1",
          linkList: [ur + "1.0.1/regist-sdk.umd.js"]
        },
        {
          label: "1.0.0",
          linkList: [ur + "1.0.0/regist-sdk.umd.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListRegistSdk.vue